<template>
    <div class="hidden lg:block w-next-nav fixed h-menu bg-next-dark-gray z-10">
        <div class="grid grid-rows-6 h-full">
            <MenuButton :to="{name:'Home', params: {id}}" icon-class="icon-home" tooltip="Home"></MenuButton>
            <div class="flex-grow grid grid-rows-6 row-span-6">
                <template v-if="id">
                    <MenuButton :to="{name:'DettaglioAzienda', params: {id}}" icon-class="icon-contatto" tooltip="Dettaglio azienda"></MenuButton>
                    <MenuButton :to="{name:'Contatti', params: {id}}" icon-class="icon-telefono" tooltip="Contatti"></MenuButton>
                    <MenuButton :to="{name:'Attivita', params: {id}}" icon-class="icon-missile" tooltip="Attività"></MenuButton>
                    <MenuButton :to="{name:'TerminiCondizioni', params: {id}}" icon-class="icon-tre_rettangoli" tooltip="Termini"></MenuButton>
                    <MenuButton :to="{name:'SottoprogettiCliente', params: {id}}" icon-class="icon-catena_verticale" tooltip="Sottoprogetti"></MenuButton>
                </template>
                <ProfileMenuButton class="row-start-6" :notification="meCounters?.notification_counter > 0"></ProfileMenuButton>
            </div>
        </div>
    </div>

    <div v-if="$store.state.menu_visible" class="lg:hidden fixed z-10 inset-0 bg-gray-500 bg-opacity-90" @click="toggle">
        <div class="flex flex-col text-white text-4xl pl-12 pt-14">
            <div class="py-4">
                <i class="self-center text-md icon-home"></i>
                <router-link :to="{name:'Dashboard'}" class="pl-4">HOME</router-link>
            </div>
            <div v-if="id" class="flex flex-col">
                <div class="py-4">
                    <i class="self-center text-md icon-contatto"></i>
                    <router-link :to="{name:'DettaglioAzienda', params: {id}}" class="pl-4">ANAGRAFICA</router-link>
                </div>
                <div class="py-4">
                    <i class="self-center text-md icon-telefono"></i>
                    <router-link :to="{name:'Contatti', params: {id}}" href="#" class="pl-4">CONTATTI</router-link>
                </div>
                <div class="py-4">
                    <i class="self-center text-md icon-missile"></i>
                    <router-link :to="{name:'Attivita', params: {id}}" href="#" class="pl-4">ATTIVITÀ</router-link>
                </div>
                <div class="py-4">
                    <i class="self-center text-md icon-tre_rettangoli"></i>
                    <router-link :to="{name:'TerminiCondizioni', params: {id}}" href="#" class="pl-4">TERMINI E CONDIZIONI</router-link>
                </div>
            </div>
            <div class="py-4">
                <i class="self-center fa fa-circle text-md"></i>
                <router-link :to="{name:'ProfiloUtente'}" class="pl-4">PROFILO</router-link>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import MenuButton from "@/components/MenuButton.vue";
import ProfileMenuButton from "@/components/ProfileMenuButton.vue";
import { mapGetters } from 'vuex';

@Options({
    name:'Menu',
    components: {
        MenuButton,
        ProfileMenuButton},
    props: {
        id: String,
    },
    computed: {
        ...mapGetters([
            'meCounters',
        ]),
    },
})
export default class Menu extends Vue {
    private $store: any;

    toggle(){
        this.$store.commit('toggle_menu')
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
